export default {
  items: [
    {
      name: 'ภาพรวม',
      url: '/dashboard/home/index',
      icon: 'icon-speedometer'
    },
    {
      name: 'บริษัททั้งหมด',
      url: '/dashboard/company/index',
      icon: 'icon-speedometer'
    },
    {
      name: 'ผู้ใช้งานทั้งหมด',
      url: '/dashboard/user/index',
      icon: 'icon-speedometer'
    },
    {
      name: 'งานทั้งหมด',
      url: '/dashboard/quote/index',
      icon: 'icon-speedometer'
    },
    {
      name: 'ส่งอีเมล',
      url: '/dashboard/email/create',
      icon: 'icon-speedometer'
    }
  ]
}
